import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import BuildingColumns from "../../../../models/ColumnDefinitions/BuildingColumns";
import BuildingSearch from "../../../../models/search/BuildingSearch";
import { hideColumns } from "../../../../models/utilities/columnHelper";
import { getBuildings } from "../../../../services/buildingService";
import TableTab from "../../../tabs/table-tab";

interface BuildingEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const BuildingEntity: FC<BuildingEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const { setFieldValue } = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds(selectIds);
    }

    return <div className="pt-3 pr-3 pl-3 h-full flex flex-col">
        <div className="flex-1 overflow-y-auto">
            <TableContextProvider
                dataMethod={getBuildings}
                useTable
                usePagination
                useFilter
                useSearch
                useSort
                tableDescriptor={BuildingColumns}
                searchDescriptor={BuildingSearch}
                maxPageSize={DEF_PG_SIZE_WIZARD}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(TranslationKeys.building)}
                    selectRows={true}
                    selectedIds={selectIds}
                    setSelectedIds={onSelectedIds}
                    tableId={'buildingEntity'}
                    cyName="buildingEntry">
                </TableTab>
            </TableContextProvider>
        </div>

        <div className="flex flex-row justify-end mt-4 pr-3 pb-3">
            <div className="flex flex-row">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    onClick={e => onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default BuildingEntity;